import type { CallbackProps } from 'hooks/tables/TableContext';
import { TableProvider } from 'hooks/tables/TableContext';
import { AdminTable } from './components/AdminTable';
import { useFetchAndLoad } from 'hooks';
import { getUnifiedAdmin } from 'services/admin.service';
import type { Admin } from 'interfaces/admin.interface';
import { sortAdapterAdmin } from '../../adapters/sort.adapter';
import { Platform } from 'enums/Platform.enum';

export default function AdminNew() {
  const APP_ID = Platform.coaching;
  const { callEndpoint, loading } = useFetchAndLoad();

  const dataAdapter = (data: Admin[]) => {
    return (
      data?.map(({ _id, Name, Email, Role, Photo }) => ({
        id: _id,
        name: Name ?? '-',
        email: Email ?? '-',
        role: Role ?? '-',
        photo: Photo,
        selected: false,
      })) ?? []
    );
  };

  const dataCallback = async (props: CallbackProps) => {
    try {
      const res = await callEndpoint(getUnifiedAdmin(props));
      return { data: res.data.data };
    } catch (error) {
      return { data: [] };
    }
  };

  const initialValuesFilter = {
    role: [],
  };

  const initialValuesProps = {
    sort: 'name-asc', // Orden alfabético por defecto
    search: '',
    data: [],
    page: 1,
    pageSize: 10,
    total: 0,
  };

  return (
    <TableProvider
      appId={APP_ID}
      initialValuesFilters={initialValuesFilter}
      initialValues={initialValuesProps}
      dataCallback={dataCallback}
      dataAdapter={dataAdapter}
      loading={loading}
      sortAdapter={sortAdapterAdmin}
    >
      <AdminTable />
    </TableProvider>
  );
}
